import React from 'react'
import PropTypes from 'prop-types'
import moment_tz from 'moment-timezone'
import cn from 'classnames'

import ArrowTop from 'app/components/SVGS/ArrowTop'
import ActivityRepeat from './ActivityRepeat'
import UserActivityAddToFavorites from 'app/domains/common/AddToFavorites'

import './styles.scss'

const bc = 'activity-header'

const ActivityHeader = ({
  proTrackNameWithLevelName,
  showRepeatButton,
  onHide,
  isExpanded,
  activityId,
  highlightFavoriteIcon,
  activityTitle,
  windowWidth,
  userTimezone,
  activityCreationDate,
}) => {
  const windowWidthMore768 = windowWidth > 768
  const activityDate = moment_tz.tz(activityCreationDate, userTimezone).format('Do MMM')
  return !isExpanded ? (
    <div className={cn(bc, `${bc}__hide`)}>
      <div
        className={cn(`${bc}__left`, {
          [`${bc}__left-hide`]: !windowWidthMore768,
        })}
      >
        <div>
          {windowWidthMore768 && `${activityDate} | ${proTrackNameWithLevelName}`}
          <span className={`${bc}__left-title`}>
            {windowWidthMore768 && ' | '}
            {activityTitle}
          </span>
        </div>
        <div className={`${bc}__left-favorite`}>
          <UserActivityAddToFavorites activityId={activityId} highlightFavoriteIcon={highlightFavoriteIcon} />
        </div>
      </div>
      <div className={`${bc}__right`}>
        <ArrowTop onClick={onHide} className={cn(`${bc}__arrow`, `${bc}__arrow-closed`)} />
      </div>
    </div>
  ) : (
    <div className={bc}>
      <div className={`${bc}__left`}>
        <div>{`${activityDate} | ${proTrackNameWithLevelName}`}</div>
        <div>{showRepeatButton && <ActivityRepeat />}</div>
      </div>
      <div className={`${bc}__right`}>
        <ArrowTop onClick={onHide} className={`${bc}__arrow`} />
      </div>
    </div>
  )
}

ActivityHeader.propTypes = {
  proTrackNameWithLevelName: PropTypes.string.isRequired,
  showRepeatButton: PropTypes.bool.isRequired,
}

export default ActivityHeader
